import Vue from "vue";
import Router from "vue-router";
import { store } from "../_store";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Unauthed routes
    {
      path: "/login",
      name: "login",
      component: () => import("../views/Login.vue")
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("../views/Logout.vue")
    },
    // Authed routes from here
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("../views/Dashboard.vue")
    },
    {
      path: "/dashboard/order/add",
      name: "addorder",
      component: () => import("../views/order/Add.vue")
    },
    {
      path: "/dashboard/order/earnings",
      name: "earnings",
      component: () => import("../views/order/Earnings.vue")
    },
    {
      path: "/dashboard/order/history",
      name: "history",
      component: () => import("../views/order/History.vue")
    }
  ]
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters["user/loggedIn"];
  const products = store.getters["user/products"];
  const carriers = store.getters["shipping/carriers"];

  if (!loggedIn && to.name !== "login") {
    return window.location.replace("/login");
  }

  if (loggedIn && (to.name === "login" || to.name === null)) {
    return window.location.replace("/dashboard");
  }

  if (loggedIn) {
    if (products === null || products.length === 0) {
      store.dispatch("user/product");
    }

    if (carriers === null || carriers.length === 0) {
      store.dispatch("shipping/getCarriers");
    }
  }

  next();
});

router.afterEach(() => {
  NProgress.done();
});
